import de_DE from './locales/de-DE.json';
import nl_NL from './locales/nl-NL.json';
import en_GB from './locales/en-GB.json';
import en_US from './locales/en-US.json';
import es_ES from './locales/es-ES.json';
export default {
    de_DE: de_DE,
    nl_NL: nl_NL,
    en_GB: en_GB,
    en_US: en_US,
    es_ES: es_ES,
};
